import {Component, inject, OnInit} from '@angular/core';
import {SuperObjectModel} from '../../core/definitions/super-object-model';
import {MAT_SNACK_BAR_DATA} from '@angular/material/snack-bar';
import {DateToolsService} from '../../core/date-tools.service';

@Component({
    selector: 'app-auto-save-snack-bar',
    templateUrl: './auto-save-snack-bar.component.html',
    styleUrls: ['./auto-save-snack-bar.component.scss'],
    standalone: false
})
export class AutoSaveSnackBarComponent implements OnInit {
  // Injections
  public data: SuperObjectModel = inject(MAT_SNACK_BAR_DATA);
  private readonly dateToolsService = inject(DateToolsService);

  updatedAt = '';

  ngOnInit(): void {
    this.updatedAt = this.dateToolsService.isoDateToString(this.data.updated_at, 'datetime');
  }

}
